/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';

export interface SetDeviceCalibrationByPast$Params {
  deviceId: number;
}

export function setDeviceCalibrationByPast(http: HttpClient, rootUrl: string, params: SetDeviceCalibrationByPast$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
  const rb = new RequestBuilder(rootUrl, setDeviceCalibrationByPast.PATH, 'post');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisteredDevice>;
    })
  );
}

setDeviceCalibrationByPast.PATH = '/api/regdevice/{deviceId}/calibration/bytime';
